import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const testimonials = [
  {
    quote:
      "What a blessing she has been. I'm so glad we randomly started talking — I didn't know how much I needed that conversation. Before we left, I asked to take a picture together so I'd never forget it.",
    who: "A wife Denise met by chance",
    featured: true,
  },
  {
    quote:
      "They don't sugarcoat anything. They tell you the truth in love, and then they walk with you while you do the work.",
    who: "A couple in Greensboro",
  },
  {
    quote:
      "We came in barely speaking to each other. We left with homework — and hope. Things are different in our house now.",
    who: "A husband, married 12 years",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="py-24 lg:py-32" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#8A5A44] mb-4">03 — Words of praise</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#2C2A28] max-w-2xl">
          People leave <em className="italic text-[#8A5A44]">praising God</em> for the conversation.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10 mt-16">
        <Reveal className="md:col-span-7">
          <figure
            className="bg-[#8A5A44] rounded-3xl p-10 lg:p-14 h-full text-[#FAF9F6]"
            data-testid="testimonial-featured"
          >
            <Quote size={32} strokeWidth={1.25} className="text-[#C4B299]" />
            <blockquote className="font-serif-display text-2xl md:text-3xl leading-snug mt-8">
              "{testimonials[0].quote}"
            </blockquote>
            <figcaption className="text-sm text-[#C4B299] mt-8 tracking-wide">
              — {testimonials[0].who}
            </figcaption>
          </figure>
        </Reveal>
        <div className="md:col-span-5 flex flex-col gap-8 lg:gap-10">
          {testimonials.slice(1).map((t, i) => (
            <Reveal key={t.who} delay={0.1 + i * 0.1} className="flex-1">
              <figure
                className="bg-[#F3EFEA] rounded-3xl p-10 h-full border border-black/5"
                data-testid={`testimonial-card-${i + 1}`}
              >
                <blockquote className="font-serif-display italic text-xl leading-snug text-[#2C2A28]">
                  "{t.quote}"
                </blockquote>
                <figcaption className="text-xs text-[#5C5854] mt-6 tracking-wide">— {t.who}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
